// extracted by mini-css-extract-plugin
export default {"fullscreenSpinner":"fullscreenSpinner_fullscreenSpinner__luPrQ","text":"fullscreenSpinner_text__Zq6IN"};